import { render, staticRenderFns } from "./change-poligon-wiki-map.vue?vue&type=template&id=7a4026a9&"
import script from "./change-poligon-wiki-map.vue?vue&type=script&lang=ts&"
export * from "./change-poligon-wiki-map.vue?vue&type=script&lang=ts&"
import style0 from "./change-poligon-wiki-map.vue?vue&type=style&index=0&id=7a4026a9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports